export class TelemetryAgentModel {
    id;
    accountId;
    name;
    description;
    createdBy;
    createdAt;
    updatedBy;
    updatedAt;
    configuration;
    logsAccountId;
    metricsAccountId;
    tracingAccountId;
    lastStatus;
    status;
}
export class TelemetryAgentSearchResponseModel extends TelemetryAgentModel {
    createdByName;
    updatedByName;
}
export class TelemetryAgentHelmConditionTemplate {
    template;
    targetElement;
    condition;
    keepAsPlaceholder;
    conditionalTemplates;
}
//# sourceMappingURL=agent.js.map